module.exports = __webpack_public_path__ + "img/priceLabs.6b0eef24.png";